/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.rise ? '增值税专用发票' : '增值税普通发票'}}</li>
    <li class="w-50 list-item-col">{{Itemize.rise || '无'}}</li>
    <li class="w-50 list-item-col">{{Itemize.duty_paragraph || '无'}}</li>
    <li class="w-50 list-item-col">{{Itemize.addressee || '无'}}</li>
    <li class="w-50 list-item-col">{{Itemize.mobile || '无'}}</li>
    <li class="w-50 list-item-col">{{Itemize.time | formatTimestamp(1)}}</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeInvoice',
    props:{
      Itemize:{}
    }
  }
</script>
